import {
  UpDownColorOption,
  UP_DOWN_COLOR_OPTION_BLUE,
  UP_DOWN_COLOR_OPTION_CYAN,
  UP_DOWN_COLOR_OPTION_PURPLE,
  UP_DOWN_COLOR_OPTION_PINK,
  UP_DOWN_COLOR_OPTION_RED,
  UP_DOWN_COLOR_OPTION_ORANGE,
  UP_DOWN_COLOR_OPTION_BROWN,
  UP_DOWN_COLOR_OPTION_GOLD,
  UP_DOWN_COLOR_OPTION_GREEN,
  UP_DOWN_COLOR_OPTION_LIME,
  UP_DOWN_COLOR_OPTION_BLACK,
  UP_DOWN_COLOR_OPTION_GRAY,
  UP_DOWN_COLOR_OPTION_LIGHT_GRAY,
  UP_DOWN_COLOR_OPTION_DARK_GRAY,
  UP_DOWN_COLOR_OPTION_WHITE,
  UP_DOWN_COLOR_OPTION_YELLOW,
  UP_DOWN_COLOR_OPTION_MAGENTA
} from '@/enums/up-down-color-options';

export interface SharpCharts2OverlaySwatch {
  upDownColorOption: UpDownColorOption;
  lineColor: string;
};

export interface ColorScheme {
  title: string;
  value: string;
  sharpCharts2Id: string;
  defaultSharpCharts2OverlayLineSwatchUpColor: string;
  defaultSharpCharts2OverlayLineSwatchDownColor: string;
  sharpCharts2GridAlphaLinesMajorOneValue: string;
  sharpCharts2GridAlphaLinesMajorTwoValue: string;
  sharpCharts2GridAlphaLinesMinorValue: string;
  sharpCharts2OverlaySwatches: SharpCharts2OverlaySwatch[];
};

export interface ColorSchemeGroup {
  groupTitle: string;
  groupIcon: string;
  colorSchemes: ColorScheme[];
};

export const COLOR_SCHEME_CUSTOM: ColorScheme = {
  title: 'Custom',
  value: 'custom',
  sharpCharts2Id: 'custom',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'd00631',
  sharpCharts2GridAlphaLinesMajorOneValue: '1.000',
  sharpCharts2GridAlphaLinesMajorTwoValue: '1.000',
  sharpCharts2GridAlphaLinesMinorValue: '0.975',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '0000aa'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '2aa198'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '9041d3'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff5bff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'd00631'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff7417'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a04a21'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '007200'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '71da00'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '111111'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '989898'
    }
  ]
};

export const COLOR_SCHEME_DARK_AMBER: ColorScheme = {
  title: 'Dark Amber',
  value: 'darkAmber',
  sharpCharts2Id: 'darkamber',
  defaultSharpCharts2OverlayLineSwatchUpColor: 'c9b03d',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'ff1111',
  sharpCharts2GridAlphaLinesMajorOneValue: '1.000',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.975',
  sharpCharts2GridAlphaLinesMinorValue: '0.650',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '0c9d02'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '36dde3'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '3583e3'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '9542dc'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_MAGENTA,
      lineColor: 'f145b2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ffa6a6'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'ff1111'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff8839'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: '935e52'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'c9b03d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: 'd7ece3'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_YELLOW,
      lineColor: 'd7d700'
    }
  ]
};

export const COLOR_SCHEME_DARK_BLUE: ColorScheme = {
  title: 'Dark Blue',
  value: 'darkBlue',
  sharpCharts2Id: 'darkblue',
  defaultSharpCharts2OverlayLineSwatchUpColor: '3583e3',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'ff1111',
  sharpCharts2GridAlphaLinesMajorOneValue: '1.000',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.975',
  sharpCharts2GridAlphaLinesMinorValue: '0.650',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_YELLOW,
      lineColor: 'd7d700'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '0ebd02'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '36dde3'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '3583e3'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '9542dc'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_MAGENTA,
      lineColor: 'f145b2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ffa6a6'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'ff1111'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff8839'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: '935e52'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'c3a76d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: 'd7ece3'
    }
  ]
};

export const COLOR_SCHEME_DARK_GRAY: ColorScheme = {
  title: 'Dark Gray',
  value: 'darkGray',
  sharpCharts2Id: 'darkgray',
  defaultSharpCharts2OverlayLineSwatchUpColor: 'bababa',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'ff1111',
  sharpCharts2GridAlphaLinesMajorOneValue: '1.000',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.975',
  sharpCharts2GridAlphaLinesMinorValue: '0.650',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_YELLOW,
      lineColor: 'd7d700'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '0ebd02'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '36dde3'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '3583e3'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '9542dc'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_MAGENTA,
      lineColor: 'f145b2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ffa6a6'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'ff1111'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff8839'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: '935e52'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'c3a76d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: 'bababa'
    }
  ]
};

export const COLOR_SCHEME_DARK_GREEN: ColorScheme = {
  title: 'Dark Green',
  value: 'darkGreen',
  sharpCharts2Id: 'darkgreen',
  defaultSharpCharts2OverlayLineSwatchUpColor: '0ebd02',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'ff1111',
  sharpCharts2GridAlphaLinesMajorOneValue: '1.000',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.975',
  sharpCharts2GridAlphaLinesMinorValue: '0.650',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_YELLOW,
      lineColor: 'd7d700'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '0ebd02'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '36dde3'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '3583e3'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '9542dc'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_MAGENTA,
      lineColor: 'f145b2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ffa6a6'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'ff1111'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff8839'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: '935e52'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'c3a76d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: 'd7ece3'
    }
  ]
};

export const COLOR_SCHEME_NIGHT: ColorScheme = {
  title: 'Night',
  value: 'night',
  sharpCharts2Id: 'night',
  defaultSharpCharts2OverlayLineSwatchUpColor: '0c9d02',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'ff1111',
  sharpCharts2GridAlphaLinesMajorOneValue: '1.000',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.813',
  sharpCharts2GridAlphaLinesMinorValue: '0.488',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '7f7fff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'ff1111'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_WHITE,
      lineColor: 'ffffff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '9640e6'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '0c9d02'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_CLASSIC: ColorScheme = {
  title: 'Classic (default)',
  value: 'default',
  sharpCharts2Id: 'default',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'd00631',
  sharpCharts2GridAlphaLinesMajorOneValue: '0.488',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.244',
  sharpCharts2GridAlphaLinesMinorValue: '0.163',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'd00631'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_BLUE: ColorScheme = {
  title: 'Blue',
  value: 'blue',
  sharpCharts2Id: 'blue',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'd00631',
  sharpCharts2GridAlphaLinesMajorOneValue: '0.488',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.244',
  sharpCharts2GridAlphaLinesMinorValue: '0.163',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'd00631'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_BLUE_GRAY: ColorScheme = {
  title: 'Blue Gray',
  value: 'blueGray',
  sharpCharts2Id: 'bluegray',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'd00631',
  sharpCharts2GridAlphaLinesMajorOneValue: '0.488',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.244',
  sharpCharts2GridAlphaLinesMinorValue: '0.163',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'd00631'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_COLOR_VISION_IMPAIRED: ColorScheme = {
  title: 'Color Vision Impaired',
  value: 'colorVisionImpaired',
  sharpCharts2Id: 'colorblind',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'ff0000',
  sharpCharts2GridAlphaLinesMajorOneValue: '0.488',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.244',
  sharpCharts2GridAlphaLinesMinorValue: '0.163',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'ff0000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_ICE: ColorScheme = {
  title: 'Ice',
  value: 'ice',
  sharpCharts2Id: 'ice',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'd00631',
  sharpCharts2GridAlphaLinesMajorOneValue: '0.488',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.244',
  sharpCharts2GridAlphaLinesMinorValue: '0.163',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'd00631'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_GRAPHITE: ColorScheme = {
  title: 'Graphite',
  value: 'graphite',
  sharpCharts2Id: 'graphite',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'd00631',
  sharpCharts2GridAlphaLinesMajorOneValue: '1.000',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.813',
  sharpCharts2GridAlphaLinesMinorValue: '0.488',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '0000aa'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '2aa198'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '9041d3'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff5bff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'd00631'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff7417'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a04a21'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '007200'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '71da00'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '989898'
    }
  ]
};

export const COLOR_SCHEME_MINT: ColorScheme = {
  title: 'Mint',
  value: 'mint',
  sharpCharts2Id: 'mint',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'd00631',
  sharpCharts2GridAlphaLinesMajorOneValue: '0.488',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.244',
  sharpCharts2GridAlphaLinesMinorValue: '0.163',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'd00631'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_MOHAVE: ColorScheme = {
  title: 'Mohave',
  value: 'mohave',
  sharpCharts2Id: 'mohave',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'd00631',
  sharpCharts2GridAlphaLinesMajorOneValue: '0.488',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.244',
  sharpCharts2GridAlphaLinesMinorValue: '0.163',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'd00631'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_MONOCHROME: ColorScheme = {
  title: 'Monochrome (print)',
  value: 'monochrome',
  sharpCharts2Id: 'monochrome',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: '000000',
  sharpCharts2GridAlphaLinesMajorOneValue: '0.488',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.244',
  sharpCharts2GridAlphaLinesMinorValue: '0.163',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIGHT_GRAY,
      lineColor: 'a0a0a0'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_DARK_GRAY,
      lineColor: '404040'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    }
  ]
};

export const COLOR_SCHEME_MURPHY: ColorScheme = {
  title: 'Murphy',
  value: 'murphy',
  sharpCharts2Id: 'murphy',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'dd0000',
  sharpCharts2GridAlphaLinesMajorOneValue: '0.488',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.244',
  sharpCharts2GridAlphaLinesMinorValue: '0.163',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'dd0000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_RAINIER: ColorScheme = {
  title: 'Rainier',
  value: 'rainier',
  sharpCharts2Id: 'rainier',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'd00631',
  sharpCharts2GridAlphaLinesMajorOneValue: '0.488',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.244',
  sharpCharts2GridAlphaLinesMinorValue: '0.163',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'd00631'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_ROSE: ColorScheme = {
  title: 'Rose',
  value: 'rose',
  sharpCharts2Id: 'rose',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'd00631',
  sharpCharts2GridAlphaLinesMajorOneValue: '1.000',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.975',
  sharpCharts2GridAlphaLinesMinorValue: '0.650',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '0000aa'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '2aa198'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '9041d3'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff5bff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'd00631'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff7417'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a04a21'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '007200'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '71da00'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '989898'
    }
  ]
};

export const COLOR_SCHEME_SAND: ColorScheme = {
  title: 'Sand',
  value: 'sand',
  sharpCharts2Id: 'sand',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'd00631',
  sharpCharts2GridAlphaLinesMajorOneValue: '0.488',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.244',
  sharpCharts2GridAlphaLinesMinorValue: '0.163',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'd00631'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_SEA_GREEN: ColorScheme = {
  title: 'Sea Green',
  value: 'seaGreen',
  sharpCharts2Id: 'seagreen',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'd00631',
  sharpCharts2GridAlphaLinesMajorOneValue: '0.488',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.244',
  sharpCharts2GridAlphaLinesMinorValue: '0.163',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'd00631'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_SOLAR: ColorScheme = {
  title: 'Solar',
  value: 'solar',
  sharpCharts2Id: 'solar',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'd00631',
  sharpCharts2GridAlphaLinesMajorOneValue: '1.000',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.894',
  sharpCharts2GridAlphaLinesMinorValue: '0.569',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '0000aa'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '2aa198'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '9041d3'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff5bff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'd00631'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff7417'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a04a21'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '007200'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '71da00'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '989898'
    }
  ]
};

export const COLOR_SCHEME_SPRUCE: ColorScheme = {
  title: 'Spruce',
  value: 'spruce',
  sharpCharts2Id: 'spruce',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'd00631',
  sharpCharts2GridAlphaLinesMajorOneValue: '1.000',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.975',
  sharpCharts2GridAlphaLinesMinorValue: '0.650',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '0000aa'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '2aa198'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '9041d3'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff5bff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'd00631'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff7417'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a04a21'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '007200'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '71da00'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '989898'
    }
  ]
};

export const COLOR_SCHEME_SUNSET: ColorScheme = {
  title: 'Sunset',
  value: 'sunset',
  sharpCharts2Id: 'sunset',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'dd0000',
  sharpCharts2GridAlphaLinesMajorOneValue: '0.488',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.244',
  sharpCharts2GridAlphaLinesMinorValue: '0.163',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'dd0000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_VANILLA: ColorScheme = {
  title: 'Vanilla',
  value: 'vanilla',
  sharpCharts2Id: 'vanilla',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'd00631',
  sharpCharts2GridAlphaLinesMajorOneValue: '0.488',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.244',
  sharpCharts2GridAlphaLinesMinorValue: '0.163',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'd00631'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_DP_BLUE: ColorScheme = {
  title: 'DP Blue',
  value: 'dpBlue',
  sharpCharts2Id: 'dpblue',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'dd0000',
  sharpCharts2GridAlphaLinesMajorOneValue: '1.000',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.650',
  sharpCharts2GridAlphaLinesMinorValue: '0.406',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'dd0000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_DP_CORAL: ColorScheme = {
  title: 'DP Coral',
  value: 'dpCoral',
  sharpCharts2Id: 'dpcoral',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'dd0000',
  sharpCharts2GridAlphaLinesMajorOneValue: '1.000',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.650',
  sharpCharts2GridAlphaLinesMinorValue: '0.406',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'dd0000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_DP_GOLD: ColorScheme = {
  title: 'DP Gold',
  value: 'dpGold',
  sharpCharts2Id: 'dpgold',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'dd0000',
  sharpCharts2GridAlphaLinesMajorOneValue: '1.000',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.650',
  sharpCharts2GridAlphaLinesMinorValue: '0.406',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'dd0000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_DP_GREEN: ColorScheme = {
  title: 'DP Green',
  value: 'dpGreen',
  sharpCharts2Id: 'dpgreen',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'dd0000',
  sharpCharts2GridAlphaLinesMajorOneValue: '1.000',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.650',
  sharpCharts2GridAlphaLinesMinorValue: '0.406',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'dd0000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_DP_PLUM: ColorScheme = {
  title: 'DP Plum',
  value: 'dpPlum',
  sharpCharts2Id: 'dpplum',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'dd0000',
  sharpCharts2GridAlphaLinesMajorOneValue: '1.000',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.650',
  sharpCharts2GridAlphaLinesMinorValue: '0.406',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'dd0000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const COLOR_SCHEME_DP_YELLOW: ColorScheme = {
  title: 'DP Yellow',
  value: 'dpYellow',
  sharpCharts2Id: 'dpyellow',
  defaultSharpCharts2OverlayLineSwatchUpColor: '000000',
  defaultSharpCharts2OverlayLineSwatchDownColor: 'dd0000',
  sharpCharts2GridAlphaLinesMajorOneValue: '1.000',
  sharpCharts2GridAlphaLinesMajorTwoValue: '0.650',
  sharpCharts2GridAlphaLinesMinorValue: '0.406',
  sharpCharts2OverlaySwatches: [
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLUE,
      lineColor: '00008b'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_RED,
      lineColor: 'dd0000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GREEN,
      lineColor: '006400'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PINK,
      lineColor: 'ff00ff'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_PURPLE,
      lineColor: '8a2be2'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_ORANGE,
      lineColor: 'ff6600'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BROWN,
      lineColor: 'a0522d'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GOLD,
      lineColor: 'daa520'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_GRAY,
      lineColor: '809099'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_BLACK,
      lineColor: '000000'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_CYAN,
      lineColor: '12FEFF'
    },
    {
      upDownColorOption: UP_DOWN_COLOR_OPTION_LIME,
      lineColor: '08FE04'
    }
  ]
};

export const DEFAULT_COLOR_SCHEME: ColorScheme = COLOR_SCHEME_MURPHY;

export const COLOR_SCHEMES_GROUPS: ColorSchemeGroup[] = [
  {
    groupTitle: 'LIGHT COLOR SCHEMES',
    groupIcon: 'far fa-fw fa-sun-cloud',
    colorSchemes: [
      COLOR_SCHEME_BLUE,
      COLOR_SCHEME_BLUE_GRAY,
      COLOR_SCHEME_COLOR_VISION_IMPAIRED,
      COLOR_SCHEME_CLASSIC,
      COLOR_SCHEME_GRAPHITE,
      COLOR_SCHEME_ICE,
      COLOR_SCHEME_MINT,
      COLOR_SCHEME_MOHAVE,
      COLOR_SCHEME_MONOCHROME,
      COLOR_SCHEME_MURPHY,
      COLOR_SCHEME_RAINIER,
      COLOR_SCHEME_ROSE,
      COLOR_SCHEME_SAND,
      COLOR_SCHEME_SEA_GREEN,
      COLOR_SCHEME_SOLAR,
      COLOR_SCHEME_SPRUCE,
      COLOR_SCHEME_SUNSET,
      COLOR_SCHEME_VANILLA
    ]
  },
  {
    groupTitle: 'DARK COLOR SCHEMES',
    groupIcon: 'far fa-fw fa-moon-stars',
    colorSchemes: [
      COLOR_SCHEME_DARK_AMBER,
      COLOR_SCHEME_DARK_BLUE,
      COLOR_SCHEME_DARK_GRAY,
      COLOR_SCHEME_DARK_GREEN,
      COLOR_SCHEME_NIGHT
    ]
  },
  {
    groupTitle: 'SPECIALITY COLOR SCHEMES',
    groupIcon: 'far fa-fw fa-star',
    colorSchemes: [
      COLOR_SCHEME_CUSTOM,
      COLOR_SCHEME_DP_BLUE,
      COLOR_SCHEME_DP_CORAL,
      COLOR_SCHEME_DP_GOLD,
      COLOR_SCHEME_DP_GREEN,
      COLOR_SCHEME_DP_PLUM,
      COLOR_SCHEME_DP_YELLOW
    ]
  }
];

export const COLOR_SCHEMES_ARRAY: ColorScheme[] = [
  COLOR_SCHEME_CLASSIC,
  COLOR_SCHEME_BLUE,
  COLOR_SCHEME_BLUE_GRAY,
  COLOR_SCHEME_COLOR_VISION_IMPAIRED,
  COLOR_SCHEME_DARK_AMBER,
  COLOR_SCHEME_DARK_BLUE,
  COLOR_SCHEME_DARK_GRAY,
  COLOR_SCHEME_DARK_GREEN,
  COLOR_SCHEME_ICE,
  COLOR_SCHEME_GRAPHITE,
  COLOR_SCHEME_MINT,
  COLOR_SCHEME_MOHAVE,
  COLOR_SCHEME_MONOCHROME,
  COLOR_SCHEME_MURPHY,
  COLOR_SCHEME_NIGHT,
  COLOR_SCHEME_RAINIER,
  COLOR_SCHEME_ROSE,
  COLOR_SCHEME_SAND,
  COLOR_SCHEME_SEA_GREEN,
  COLOR_SCHEME_SOLAR,
  COLOR_SCHEME_SPRUCE,
  COLOR_SCHEME_SUNSET,
  COLOR_SCHEME_VANILLA,
  COLOR_SCHEME_CUSTOM,
  COLOR_SCHEME_DP_BLUE,
  COLOR_SCHEME_DP_CORAL,
  COLOR_SCHEME_DP_GOLD,
  COLOR_SCHEME_DP_GREEN,
  COLOR_SCHEME_DP_PLUM,
  COLOR_SCHEME_DP_YELLOW
];

export function getColorSchemeObjFromColorSchemeValue(colorSchemeValue: string): ColorScheme {
  return COLOR_SCHEMES_ARRAY.find(option => option.value === colorSchemeValue) ?? DEFAULT_COLOR_SCHEME;
}
